<button mat-stroked-button class="facade" [color]="color" [disabled]="disabled" (click)="clickHandlerMethod($event)">
  <ng-content></ng-content>
</button>
